import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Box from '@mui/material/Box';
import { BsUpload } from 'react-icons/bs';
import { TailSpin } from 'react-loader-spinner';
import { toast } from 'react-toastify';

import TaskInformation from '../TaskInformation';
import ValidationButton from '../ValidationButton';
import PreviewButton from '../PreviewButton';

import { addMetaDataToFile, uploadFile, deleteFileImage } from '../../../store/action/fileManagement';
import {completeTask, getTask} from '../../../store/action/taskAction';
import { createFinancialDocument, updateReparationMission } from '../../../store/action/claimManagement';
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import PreviewPDF from '../PreviewPDF';
import MaskedDecimalInput from "../../../utils/MaskedDecimalInput";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'flex',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    leftSection: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        flexDirection: 'column',
    },
    rightSection: {
        flex: 1,
        padding: '20px',
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputTextArea: {
        width: '100%',
        marginBottom: '20px',
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: '100%',
        height: '36px',
        borderRadius: 4,
        marginBottom: '20px',
    },
    uploadRectangle: {
        width: '519px',
        height: '374px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);',
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(187, 200, 8, 1)',
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    hiddenInput: {
        display: 'none',
    },
    previewBtn: {
        position: 'absolute',
       // background: 'rgb(243, 246, 249)',
        right: '-165px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
}));
const commonButtonStyle = {
    fontFamily: 'Poppins',
    fontSize: '10.76px',
    fontWeight: 600, 
    border: 'none',
    cursor: 'pointer',
    opacity: '0px',
    borderRadius: '5.38px', 
};
const annulerStyle = {
    ...commonButtonStyle,
    width: 'fit-content',
    height: '36px',
    backgroundColor: 'rgba(229, 234, 238, 1)',
    color: 'rgb(225, 31, 31)', 
    marginRight : '20px'
};
const UploadQuotation_invoices = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch();

    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [loading, setLoading] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const currentUser = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const processName = task?.processDefinitionId.split(':')[0];
    const [totalAmountWOTax, setTotalAmountWOTax] = useState('0.000');
    const [totalAmountWTax, setTotalAmountWTax] = useState('0.000');
    const [estimatedEntryDate, setEstimatedEntryDate] = useState('');
    const [addAdditionalDevis, setAddAdditionalDevis] = useState(false);
    const [uid, setUid] = useState('');
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [openPreviewPDF, setOpenPreviewPDF] = useState(false);

    useEffect(() => {
        setTotalAmountWOTax('0.000');
        setTotalAmountWTax('0.000');
    }, []);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, currentUser);
                setTask(response)
                setInfoSinistre(response?.businessKey)
                setVariables(response?.variables)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, currentUser]);

    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)

    const repartionMissionId = task?.variables?.repartionMissionId?.value; 


    const handleUploadClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleFileChange = async (event) => { 
        setLoading(true);
        const file = event.target.files?.[0];
        if (!file) return;

        const validType = 'application/pdf';
        if (file.type !== validType) {
            toast.error("Seuls les fichiers PDF sont acceptés");
            setLoading(false);
            return;
        }

        const fileUrl = URL.createObjectURL(file);
        setPdfUrl(fileUrl);

        const formData = new FormData();
        formData.append('fileUploaded', file);
        formData.set('createdBy', currentUser);
        formData.set('key', 'NUM_SIN');
        formData.set('value', task.businessKey);

        const documentType = processName === 'UPLOAD_QUOTATION' ? 'QUOTATION' : 'INVOICE';

        try {
            const response = await dispatch(uploadFile(formData));
            const uid = response.uid;
            setUid(uid);

            const metaData = {
                key: 'TYPE_DOCUMENT',
                value: documentType,
            };

            await dispatch(addMetaDataToFile(uid, metaData));
        } catch (error) {
            console.log(error);
            toast.error("Une erreur est survenue lors de l'ajout du fichier");
        } finally {
            setLoading(false);
        }
    };

    const validateInputs = () => {
        const validationErrors = [];

        if (!uid && !( task?.variables?.managementType?.value === 'AfriqueAssistance' )) {
            validationErrors.push(`Veuillez télécharger le ${processName === 'UPLOAD_INVOICE' ? 'facture' : 'devis'}`);
        }

        if (!totalAmountWOTax || isNaN(parseFloat(totalAmountWOTax))) {
            validationErrors.push("Le montant total HT est requis et doit être un nombre valide");
        } else if (!parseFloat(totalAmountWOTax) > 0) {
            validationErrors.push("Le montant total HT ne peut pas être null");
        }

        if (!totalAmountWTax || isNaN(parseFloat(totalAmountWTax))) {
            validationErrors.push("Le montant total TTC est requis et doit être un nombre valide");
        } else if (!parseFloat(totalAmountWTax) > 0) {
            validationErrors.push("Le montant total TTC ne peut pas être null");
        }

        if (totalAmountWOTax && totalAmountWTax &&
            parseFloat(totalAmountWTax) < parseFloat(totalAmountWOTax)) {
            validationErrors.push("Le montant TTC doit être supérieur ou égal au montant HT");
        }

        if (processName !== 'UPLOAD_INVOICE' && !estimatedEntryDate) {
            validationErrors.push("La date d'entrée prévisionnelle est requise");
        }

        return validationErrors;
    };

    const handleQuotationValidation = async () => {
        const validationErrors = validateInputs();
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            const financialDocument = {
                type: 'QUOTATION',
                associatedDocument: uid,
                totalAmountWOTax: parseFloat(totalAmountWOTax),
                totalAmountWTax: parseFloat(totalAmountWTax),
                associatedClaimNumber: task.businessKey,
                status: task?.variables?.claimExpertId ? 'RECEIVED' : 'VALID'
            };

            const repartitionObject = {
                estimatedReparationEntryDate: estimatedEntryDate,
            };

            await updateReparationMission(repartionMissionId, repartitionObject);

            const updatedVariables = {
                ...variables,
                reparationAmount: {
                    value: parseFloat(totalAmountWTax),
                    type: 'Double',
                }
            };

            await dispatch(createFinancialDocument(financialDocument));
            await dispatch(completeTask(taskId, currentUser, updatedVariables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error('Error in quotation validation:', error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    };

    const handleInvoiceValidation = async () => {
        const validationErrors = validateInputs();
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            const financialDocument = {
                type: 'INVOICE',
                associatedDocument: uid,
                totalAmountWOTax: parseFloat(totalAmountWOTax),
                totalAmountWTax: parseFloat(totalAmountWTax),
                associatedClaimNumber: task.businessKey,
                status: task?.variables?.claimExpertId ? 'RECEIVED' : 'VALID'
            };

            const updatedVariables = {
                ...variables,
                invoiceValidated: {
                    value: addAdditionalDevis,
                    type: 'Boolean',
                },
                existComplementaryQuote: {
                    value: addAdditionalDevis,
                    type: 'Boolean',
                }
            };

            await dispatch(createFinancialDocument(financialDocument));
            await dispatch(completeTask(taskId, currentUser, updatedVariables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error('Error in invoice validation:', error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    };

    const handleValidation = () => {
        if (processName === 'UPLOAD_QUOTATION') {
            handleQuotationValidation();
        } else if (processName === 'UPLOAD_INVOICE') {
            handleInvoiceValidation();
        }
    };

    useEffect(() => {
        if (task?.assignee === currentUser) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task]);
    const handleDeleteFile = async () => {
        setPdfUrl(null);
        setUid(null);
        try {
            await dispatch(deleteFileImage(uid));
            setRefresh(!refresh);
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };
    
    const handleInputChange = (event) => {
        const { name, value } = event.target;
    
        // Allow empty string or valid number with up to 3 decimal digits
        const regex = /^\d*(\.|,)?\d{0,3}$/;
    
        // Normalize comma to dot
        const normalizedValue = value.replace(',', '.');
    
        if (regex.test(normalizedValue)) {
            if (name === 'totalAmountWOTax') {
                setTotalAmountWOTax(normalizedValue);
            } else if (name === 'totalAmountWTax') {
                setTotalAmountWTax(normalizedValue);
            }
        }
    };
    
      
    return (
        <div className={classes.root}>
           
           <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
                    <div className={classes.leftSection}>
                        {pdfUrl ? (
                            <><div className={classes.uploadRectangle}>
                                    <div className={classes.uploadTextPrimary}>
                                        Prévisualiser votre {processName === 'UPLOAD_INVOICE' ? 'facture' : 'devis'}
                                    </div>
                                    {loading ? (
                                        <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"} />
                                    ) : (
                                        <div style={{ textAlign: 'center' }}>
                                     <div style={{ position: 'relative', width: '375px', height: '325px' }}>
                                            <iframe
                                                src={pdfUrl}
                                                width="375"
                                                height="325"
                                                title="PDF Viewer"
                                                style={{ pointerEvents: 'none' }}
                                            />
                                            <div
                                                onClick={() => {
                                                    if (pdfUrl) {
                                                        setOpenPreviewPDF(true);
                                                    }
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    cursor: 'pointer',
                                                    backgroundColor: 'transparent',
                                                }}
                                            ></div>
                                        </div>

                                    </div>
                                    
                                    )}
                                </div><button
                                    style={annulerStyle}
                                    onClick={() => {
                                        handleDeleteFile();
                                    } }
                                >
                                        Supprimer le fichier
                                    </button></>
                        ) : (
                            <div className={classes.uploadRectangle} onClick={handleUploadClick}>
                                <BsUpload style={{ color: 'rgba(187, 200, 8, 1)' }} size={40} />
                                <div className={classes.uploadTextPrimary}>
                                    Ajoutez votre {processName === 'UPLOAD_INVOICE' ? 'facture' : 'devis'}
                                </div>
                                <div className={classes.uploadTextSecondary}>
                                    Déposez votre {processName === 'UPLOAD_INVOICE' ? 'facture' : 'devis'} ou{' '}
                                    <u style={{ color: 'rgba(187, 200, 8, 1)' }}>parcourir</u> un fichier depuis votre ordinateur.
                                </div>
                                <input
                                    id="fileInput"
                                    accept="application/pdf"
                                    type="file"
                                    className={classes.hiddenInput}
                                    disabled={isTaskClaimed}
                                    onInput={handleFileChange}
                                />
                            
                            </div>
                        )}
                    </div>
                    <div className={classes.rightSection}>
                    <div>
                        <label className={classes.inputLabel}>Total des réparations Sans Tax</label>
                        <MaskedDecimalInput
                            className={classes.inputContainer}
                            name="totalAmountWOTax"
                            disabled={isTaskClaimed}
                            value={totalAmountWOTax}
                            onChange={(value) => setTotalAmountWOTax(value)}
                        />
                    </div>
<div>
    <label className={classes.inputLabel}>Total des réparations TTC</label>
    <MaskedDecimalInput
        className={classes.inputContainer}
        name="totalAmountWTax"
        disabled={isTaskClaimed}
        value={totalAmountWTax}
        onChange={(value) => setTotalAmountWTax(value)}
    />
</div>

                        {processName != 'UPLOAD_INVOICE' ? (
                            <div>
                                <label className={classes.inputLabel}>Date d'entrée prévisionnelle</label>
                                <input
                                    type="date"
                                    className={classes.inputContainer}
                                    name="estimatedEntryDate"
                                    disabled={isTaskClaimed}
                                    value={estimatedEntryDate}
                                    min={task?.variables?.occurrenceDate?.value}
                                    onChange={(e) => setEstimatedEntryDate(e.target.value)}
                                />
                            </div>
                        ) : (
                            <div>
                                <label className={classes.inputLabel}>Avez-vous ajouté un devis complémentaire ?</label>
                                <div>
                                    <input
                                        type="radio"
                                        id="yes"
                                        name="additionalDevis"
                                        value="yes"
                                        checked={addAdditionalDevis}
                                        disabled={isTaskClaimed}
                                        onChange={() => setAddAdditionalDevis(true)}
                                    />
                                    <label htmlFor="yes">Oui</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="no"
                                        name="additionalDevis"
                                        value="no"
                                        checked={!addAdditionalDevis}
                                        disabled={isTaskClaimed}
                                        onChange={() => setAddAdditionalDevis(false)}
                                    />
                                    <label htmlFor="no">Non</label>
                                </div>
                            </div>
                        )}
                    </div>
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
        </div>
            <ValidationButton taskId={taskId} handleValidation={() =>isTaskClaimed? null : handleValidation()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
            <PreviewPDF pdfUrl={pdfUrl} open={openPreviewPDF} onClose={() => setOpenPreviewPDF(false)} />
        </div>
    );
};

export default UploadQuotation_invoices;
